import { Injectable } from '@angular/core';
import { DynamicTableColumnModel } from '../../models/dto/core/dynamicTableColumn.model';
import { SessionStorageService } from '../session-storage.service';
import { StringUtils } from '../../utils/string.utils';
import { ArrayUtils } from '../../utils/array.utils';

@Injectable({
  providedIn: 'root'
})
export class ColumnVisibleService {
  localStoragePrefix: string = "column";
  constructor(private sessionStorageService: SessionStorageService) { }

  getKey(screenCode: string, reportType: string | null) {
    if (StringUtils.isNotEmpty(reportType))
      return this.localStoragePrefix + "." + screenCode + "." + reportType;
    else
      return this.localStoragePrefix + "." + screenCode;
  }

  getVisibleColumns(screenCode: string, reportType: string | null) {
    const key = this.getKey(screenCode, reportType);
    const storedColumnFields: string[] = this.sessionStorageService.getJSONData(key);

    if (storedColumnFields) {
      return storedColumnFields;
    }
    else {
      return [];
    }
  }

  setVisibleColumns(screenCode: string, reportType: string, columns: string[]) {
    const key = this.getKey(screenCode, reportType);
    this.sessionStorageService.setJSONData(key, columns);
  }

  prepareSelectedColumns(screenCode: string, reportType: string | null, columns: DynamicTableColumnModel[]) {

    let initialColumns: DynamicTableColumnModel[] = JSON.parse(JSON.stringify(columns));
    const fields = this.getVisibleColumns(screenCode, reportType);
    let selectedColumns;

    if (fields.length > 0) {
      selectedColumns = initialColumns.filter((x) => fields.indexOf(x.field!) > -1);
    }
    else {
      selectedColumns = initialColumns.filter((x) => x.isSelected || (x.reportType != null && x.reportType.indexOf(reportType) > -1));
    }

    selectedColumns.forEach(x => x.isSelected = true);

    // fields dizisindeki sıraya göre selectedColumns dizisini sırala
    selectedColumns = ArrayUtils.sortByValues(selectedColumns, "field", fields);


    return selectedColumns;

  }

  getInitialVisibleColumn(reportType: string, columns: DynamicTableColumnModel[]): string[] {
    return columns.filter((x) => !x.isHidden && (x.isSelected || (x.reportType != null && x.reportType!.indexOf(reportType) > -1)))
      .map((y) => y.field!) ?? [];
  }


}
